import { CODE_LENGTH } from "@cslame/shared";

interface Props {
  revealed: string;
  position: number;
  status: "idle" | "active" | "cashed_out" | "busted";
}

export function LCD({ revealed, position, status }: Props) {
  const slots: { char: string; state: "on" | "cursor" | "off" }[] = [];
  for (let i = 0; i < CODE_LENGTH; i++) {
    if (i < revealed.length) {
      slots.push({ char: revealed[i]!, state: "on" });
    } else if (i === position && status === "active") {
      slots.push({ char: "_", state: "cursor" });
    } else {
      slots.push({ char: "*", state: "off" });
    }
  }
  const label =
    status === "busted"
      ? "BOMB"
      : status === "cashed_out"
        ? "DEFUSED"
        : status === "active"
          ? "ARMED"
          : "STANDBY";
  return (
    <div className={`lcd ${status === "busted" ? "lcd-alarm" : ""}`}>
      <div className="lcd-header">
        <span>M11-C4</span>
        <span className="lcd-status">{label}</span>
      </div>
      <div className="lcd-body">
        {slots.map((s, i) => (
          <span
            key={i}
            className={`lcd-digit ${s.state === "off" ? "off" : ""} ${
              s.state === "cursor" ? "cursor" : ""
            }`}
          >
            {s.char}
          </span>
        ))}
      </div>
    </div>
  );
}
